<script setup lang="ts">
interface Props {
  /**
   * Title for empty state
   */
  title?: string;
  /**
   * Subtitle/description
   */
  subtitle?: string;
  /**
   * Illustration image path
   */
  illustration?: string;
}

const props = withDefaults(defineProps<Props>(), {
  title: "",
  subtitle: "",
  illustration: "",
});
</script>

<template>
  <div class="list-empty flex flex-col items-center justify-center">
    <slot name="illustration">
      <img
        class="list-empty__illustration"
        :src="illustration || '/images/empty-box.svg'"
        alt=""
        aria-hidden="true"
        loading="lazy"
      />
    </slot>

    <div class="list-tempty__copy flex flex-col gap-[4px] text-center">
      <slot name="title">
        <div v-if="title" class="text-body-primary">{{ title }}</div>
      </slot>

      <slot name="subtitle">
        <div
          v-if="subtitle"
          class="list-empty__subtitle text-body-small-tertiary"
        >
          {{ subtitle }}
        </div>
      </slot>
    </div>

    <slot name="action"></slot>
  </div>
</template>

<style scoped lang="scss">
.list-empty {
  gap: token("gap-medium");
  padding: token("padding-4xlarge") token("padding-xlarge");

  &__illustration {
    width: 120px;
    height: 120px;
    object-fit: contain;
    pointer-events: none;
    user-select: none;
  }
  &__subtitle {
    color: token("color-content-neutral-medium");
  }
}
</style>
